/**
 * Persist launch-notify signup so returning visitors still see the product preview.
 */
(function () {
  const STORAGE_KEY = 'fraire-password-launch-notify';

  const init = () => {
    const root = document.querySelector('.fraire-password-landing');
    if (!root) return;

    const signup = root.querySelector('[data-fraire-password-signup]');
    const thanks = root.querySelector('[data-fraire-password-thanks]');
    if (!signup || !thanks) return;

    const showThanks = () => {
      signup.setAttribute('hidden', '');
      thanks.removeAttribute('hidden');
      try {
        localStorage.setItem(STORAGE_KEY, '1');
      } catch (e) {}
    };

    if (!thanks.hasAttribute('hidden')) {
      showThanks();
      return;
    }

    try {
      if (localStorage.getItem(STORAGE_KEY) === '1') {
        showThanks();
      }
    } catch (e) {}
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
